import { combineReducers } from 'redux';
import pmReducer from './entities/pm';

export default combineReducers({
  pm: pmReducer,
});
